import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/_side-layout/settings_/privacy/')({
  beforeLoad: () => {
    throw redirect({ to: '/settings/privacy/user-consent' });
  },
});
